export default function SimpleTagsComponent() {
  return {
    require: 'ngModel',
    template: require('./simple-tags.html'),
    restrict: 'E',
    scope: {
      ngModel: '=',
      name: '='
    },
    controller: SimpleTagsController
  };


  function SimpleTagsController($scope) {
    'ngInject';
    var generateEmails = function () {
      if ($scope.ngModel) {
        $scope.emailsModel = [];

        angular.forEach($scope.ngModel, function (value) {

          $scope.emailsModel.push({
            "text": value
          });

        });

      } else {
        $scope.emailsModel = [];
      }
    };

    var hasUpdated = false;

    $scope.$watch('ngModel', function (val) {
      if (val && !hasUpdated) {
        generateEmails();
        hasUpdated = true;
      }
    });

    $scope.updateTags = function () {

      var result = [];
      angular.forEach($scope.emailsModel, function (value) {

        result.push(value.text);

      });

      $scope.ngModel = result;
    };
  }
}